/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowPetAdoptionEventTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowPetAdoptionEvent,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Find a Furry Friend!",
    "Adopt, Don’t Shop!",
    "Let’s Save Lives!",
  ],
  title: "Pet Adoption Event",
  description: "Organize a meaningful pet adoption event.",
  longDescription:
    "Gather your friends to help find homes for pets! Choose a date, plan activities for the event, and decide on refreshments!",
  emoji: "🐾",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Pet Adoption Event",
          emoji: "🐾",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the pet adoption event?",
          emoji: "📅",
          completeAction: {
            question: "Decide on activities for the event?",
            description:
              "What activities should we include to make the event fun?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we plan?",
                emoji: "🎉",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we provide for attendees?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we have?",
                      emoji: "🍪",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Save Some Lives!",
    outroDescription:
      "Your pet adoption event plans are set! Enjoy making a difference!",
  },
};
